import styled from "styled-components";

export const GameClubMyWrapper = styled.div`
  margin: 50px 16px 20px;
  position: fixed;
  padding-top: 20px;
  height: 100%;
  overflow: auto;
  padding-bottom: 250px;
  width: calc(100% - 32px);

  > .no-data {
    font-weight: 300;
    font-size: 12px;
    text-align: center;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    > .button {
      padding: 8px 17px;
      border-radius: 8px;
      background: #d91818;
      color: #fff;

      font-size: 11px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.18px;
    }
  }
`;

export const GameClubMyDataWrapper = styled.div`
  position: relative;
  background: #1f212799;
  border-radius: 8px;
  width: 100%;
`;

export const GameClubMyClubWrapper = styled.div`
  padding: 0 16px 14px 16px;
  color: #fff;
  display: flex;
  gap: 10px;
  color: #fff;
  flex-direction: row;
`;

export const GameClubMyClubBox = styled.div`
  > .club-profile-background {
    width: 140px;
    height: 178px;
    background: url("/image-web/game/club/club_profile_flag.png");
    background-size: cover;
    background-position: center;
    position: relative;

    > .club-profile-background-image {
      position: absolute;
      width: 80px;
      height: 85px;

      top: 35px;
      left: 30px;
      object-fit: cover;
    }

    > .club-profile-image {
      width: 50px;
      height: 50px;
      position: absolute;
      top: 48px;
      left: 46px;
    }

    > .club-profile-background-image-edit {
      position: absolute;
      top: 89px;
      left: 81px;
      width: 30px;
      height: 30px;
    }

    > .club-name {
      position: absolute;
      top: 125px;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: -0.3px;
    }

    > .club-profile-background-image-edit-btn {
      position: absolute;
      top: 96px;
      left: 86px;
    }
  }
`;

export const GameClubMyClubInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
  flex: 1;
`;

export const GameClubMyClubInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

export const GameClubMyClubInfoItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  width: 100%;
  > .title {
    width: 45px;
    height: 14px;
    color: #fff;
    font-family: Pretendard;
    text-align: left;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%; /* 14px */
  }

  > .content {
    flex: 1;
    display: flex;
    align-items: center;
    width: 91px;
    height: 25px;
    padding: 0px 6px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    font-family: Pretendard;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%; /* 14px */
  }
`;

export const GameClubMyClubInfoButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 100%;
`;

export const GameClubMyClubInfoButton = styled.div`
  flex: 1;
  border-radius: 8px;
  border: 1px solid transparent;
  background-image: linear-gradient(#000, #000),
    linear-gradient(160.42deg, #ffcd57 33.13%, #ffffff 50%, #b68411 76.39%);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.26px;
  padding: 8.5px 0;
`;

export const GameClubDescriptionWrapper = styled.div`
  padding: 8px;
  margin: 0 16px;
  width: calc(100% - 32px);
  height: 83px;
  border-radius: 8px;
  border: 1.5px solid transparent;
  background-image: linear-gradient(#000, #000),
    linear-gradient(164.42deg, #ffcd57 33.13%, #ffffff 50%, #b68411 76.39%);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  color: #fff;
  font-family: Pretendard;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.26px;
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;

export const GameClubMyRankWrapper = styled.div`
  padding: 20px 16px 42px;
`;

export const GameClubMyRankHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
  > .title {
    color: #fff;

    font-weight: 800;
    font-size: 16px;
  }

  > .filter {
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
`;
export const GameClubMyRankContentInfo = styled.div`
  position: absolute;
  z-index: 100;
  top: 20px;
  right: 0px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  background-image: linear-gradient(#121212, #121212),
    linear-gradient(
      166.29deg,
      #ba643a 0.22%,
      #ffffff 38.14%,
      #7addeb 66.57%,
      #836623 100%
    );
  background-origin: border-box;
  background-clip: padding-box, border-box;
  color: #fff;

  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.18px;
`;

export const GameClubMyRankContent = styled.div`
  color: #fff;
  margin-top: 12px;

  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    > .name {
      font-weight: 600;
      font-size: 12px;

      > span {
        font-weight: 600;
        color: #dedede;
      }
    }

    > img {
      margin-right: 12px;
    }
  }

  > .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;

    > .tire-wrapper {
      > img {
        width: 37px;
        height: auto;
      }

      > .tire {
        font-weight: 600;
        font-size: 11px;
        text-align: center;
        color: #dedede;
        width: 55px;
      }
    }
  }
`;

export const GameClubMyRankBar = styled.div<{ bar: number }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 8px;
  height: 46;
  border-radius: 8px;
  padding: 10px;
  background: #ffffff1a;

  > .bar {
    background: #ffffff4d;
    width: 100%;
    height: 10px;
    border-radius: 8px;
    position: relative;
    > .bar-color {
      position: absolute;
      width: ${(prop) => prop.bar}%;
      min-width: 2%;
      height: 10px;
      border-radius: 8px;
      background: linear-gradient(
        90deg,
        #ffa071 1.27%,
        #a04e25 63.84%,
        #d69555 122.1%
      );
    }
  }

  > .score {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .item {
      font-weight: 800;
      font-size: 10px;

      > span {
        font-weight: 300;
        font-size: 10px;
      }
    }
  }
`;
